/* Upfit Allwear — polish layer. Pairs with upfit-polish.css.
   Scroll reveal, staggered cards, stat count-up, style-code tags. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return; // keep the theme editor static

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;
  var STYLE_CODE = /^[A-Z]{1,4}-?\d{2,5}[A-Z]?$/;

  /* --- Style-code tag on product cards ----------------------------- */
  function tagCards(root) {
    root.querySelectorAll('product-card:not([data-uf-tagged])').forEach(function (card) {
      card.setAttribute('data-uf-tagged', '');
      var title = card.querySelector('.product-card__link .visually-hidden');
      var gallery = card.querySelector('.card-gallery');
      if (!title || !gallery) return;
      var code = title.textContent.trim().split(/\s+/)[0] || '';
      if (!STYLE_CODE.test(code)) return;
      var tag = document.createElement('span');
      tag.className = 'uf-style-tag';
      tag.setAttribute('aria-hidden', 'true');
      tag.textContent = code;
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      gallery.appendChild(tag);
    });
  }

  /* --- Scroll reveal ------------------------------------------------ */
  var revealObserver =
    canObserve && !reduce
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('uf-in');
              revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
        )
      : null;

  function markReveals(root) {
    if (!revealObserver) return;
    var fold = window.innerHeight;

    function mark(el, delay) {
      if (el.hasAttribute('data-uf-reveal')) {
        // A re-render can drop the .uf-in class; never leave it hidden.
        if (!el.classList.contains('uf-in')) revealObserver.observe(el);
        return;
      }
      // Anything already on screen at load stays put — no flash on first paint.
      if (el.getBoundingClientRect().top < fold) return;
      el.setAttribute('data-uf-reveal', '');
      if (delay) el.style.setProperty('--uf-delay', delay + 'ms');
      revealObserver.observe(el);
    }

    // Product cards: stagger within their own grid/list
    root.querySelectorAll('.resource-list, .product-grid').forEach(function (list) {
      list.querySelectorAll('.resource-list__item, .product-grid__item').forEach(function (item, i) {
        mark(item, Math.min(i % 8, 5) * 60);
      });
    });

    // Section headings and stat rows
    root
      .querySelectorAll('main .shopify-section h2, main .shopify-section .uf-stats__item')
      .forEach(function (el, i) {
        mark(el, el.classList.contains('uf-stats__item') ? (i % 4) * 80 : 0);
      });
  }

  /* --- Stat count-up ------------------------------------------------ */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-uf-count'));
    if (isNaN(target)) return;
    if (reduce) {
      el.textContent = target.toLocaleString();
      return;
    }
    var start = null;
    var duration = 1200;
    function tick(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function watchCounts(root) {
    var els = root.querySelectorAll('[data-uf-count]:not([data-uf-counted])');
    if (!els.length) return;
    if (!canObserve) return; // server-rendered final values stay as they are
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          countUp(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) {
      el.setAttribute('data-uf-counted', '');
      io.observe(el);
    });
  }

  function run(root) {
    tagCards(root);
    markReveals(root);
    watchCounts(root);
  }

  function init() {
    if (!reduce) document.documentElement.classList.add('uf-motion');
    run(document);

    // Filters, pagination and quick-add re-render cards — pick up new ones.
    var main = document.getElementById('MainContent');
    if (!main || !('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        run(main);
      });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
